import { render } from "./vresourcesexamine.vue?vue&type=template&id=8cb900f2&scoped=true"
import script from "./vresourcesexamine.vue?vue&type=script&lang=js"
export * from "./vresourcesexamine.vue?vue&type=script&lang=js"

import "./vresourcesexamine.vue?vue&type=style&index=0&id=8cb900f2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb900f2"]])

export default __exports__